import React from 'react'
import { StyleSheet } from 'react-native'
import { Spacing, Text, TextProps } from 'zens-storybook'
import { useBuilding, useFloor, useLocation } from 'zens-store'

const styles = StyleSheet.create({
  container: {
    marginTop: Spacing.XS,
  },
})

interface Props extends TextProps {
  value: number
  companyId: number
}
const FloorField = (props: Props) => {
  const { value: floorId, companyId, style, ...otherProps } = props
  const floor = useFloor({ companyId, floorId })
  const building = useBuilding({
    companyId,
    buildingId: floor.data?.buildingId || NaN,
  })
  const location = useLocation({
    companyId,
    locationId: building?.data?.locationId || NaN,
  })
  return (
    <Text style={[styles.container, style]} {...otherProps}>
      {location.data?.name}, {floor.data?.displayName} ({building.data?.name})
    </Text>
  )
}

export default FloorField
